import { render } from "./ViewSociete.vue?vue&type=template&id=264d0a87&ts=true"
import script from "./ViewSociete.vue?vue&type=script&lang=ts"
export * from "./ViewSociete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__